import { useEffect } from 'react';
import { routeHistory } from '@nackle/biw-web-router';

/**
 * Renders nothing and immediately redirects the current URL to its new location.
 *
 * `from`/`to` are path fragments (without the company UUID prefix). The first
 * occurrence of `from` in the current pathname is swapped for `to`, so any
 * trailing segments (e.g. /create, /edit/:id) and the query string are preserved.
 * Used to keep historical URLs working after the navigation restructure.
 */
export const Redirect = ( { from, to } ) => {
    useEffect( () => {
        const { pathname, search, hash } = window.location;
        const next = pathname.replace( from, to ) + ( search || '' ) + ( hash || '' );
        routeHistory.replace( next );
    }, [] );

    return null;
};
